import EnumService from '../EnumService'

export default class EstadoCivilEnumService extends EnumService{

    constructor(){
        super('enumEstadoCivil');
    }
  
  }